module.exports = __webpack_public_path__ + "assets/img/login.1268fcd6.jpg";